import React, { CSSProperties, ReactNode } from "react";
import { Button } from "react-bootstrap";

interface InfoBannerProps {
    children?: ReactNode;
    positionIcon?: "center" | "top" | "start";
    iconClassColor?: string;
    classIcon?: string;
    backgroundColor?: string;
    textColor?: string;
    isCloseButton?: boolean;
    marginClasses?: string;
    className?: string;
    iconStyle?: CSSProperties;
}

const InfoBanner: React.FC<InfoBannerProps> = ({
    children,
    positionIcon = "center",
    iconClassColor,
    classIcon = "bi-info-circle",
    backgroundColor = "violet-light",
    textColor = "violet-hover",
    isCloseButton,
    marginClasses = "mb-4",
    className = "",
    iconStyle,
}) => {
    return (
        <div
            className={`d-flex align-items-${positionIcon} gap-2 px-6 py-2 ${marginClasses} rounded bg-${backgroundColor} text-${textColor} rounded-1 ${className}`}
        >
            <i
                className={`bi ${classIcon} fs-normal d-flex align-items-center ${iconClassColor ? iconClassColor : ""}`}
                style={iconStyle}
            ></i>
            <div className="fs-7">{children}</div>
            {isCloseButton ? (
                <Button variant="link" className={`ms-auto fs-16 p-0 text-${textColor}`}>
                    <i className="bi bi-x-lg"></i>
                </Button>
            ) : null}
        </div>
    );
};

export default InfoBanner;
